var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md cart-null"},[_c('img',{attrs:{"src":_vm.cartImage}}),_c('span',[_vm._v(_vm._s(_vm.$t('popup.shoppingcart.item.empty')))])])}
var staticRenderFns = []

export { render, staticRenderFns }